import React from 'react';
import { render } from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { store, history, persistor } from './store';
import './bulma.min.css';
import './normalize.min.css';
import './index.css';
import './noty.min.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root'));

serviceWorker.unregister();
